var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "d-inline-flex"
    },
    [
      _c(
        "v-menu",
        {
          attrs: {
            "offset-y": "",
            left: "",
            disabled: _vm.locked
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function fn(_ref) {
                var on = _ref.on,
                  attrs = _ref.attrs
                return [
                  _c(
                    "gg-btn",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "kvm-power-menu__btn",
                          attrs: {
                            secondary: "",
                            loading: !!_vm.pending,
                            disabled: _vm.locked,
                            "aria-label": "Power options"
                          }
                        },
                        "gg-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            left: "",
                            small: "",
                            "aria-hidden": "true"
                          }
                        },
                        [_vm._v("mdi-power")]
                      ),
                      _vm._v("Power "),
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            right: "",
                            small: "",
                            "aria-hidden": "true"
                          }
                        },
                        [_vm._v("mdi-menu-down")]
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c(
            "v-list",
            {
              attrs: {
                dense: ""
              }
            },
            _vm._l(_vm.options, function(opt) {
              return _c(
                "v-list-item",
                {
                  key: opt.action,
                  on: {
                    click: function click($event) {
                      return _vm.choose(opt)
                    }
                  }
                },
                [
                  _c(
                    "v-list-item-icon",
                    {
                      staticClass: "mr-3"
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            small: "",
                            color: opt.color,
                            "aria-hidden": "true"
                          }
                        },
                        [_vm._v(_vm._s(opt.icon))]
                      )
                    ],
                    1
                  ),
                  _c("v-list-item-title", [_vm._v(_vm._s(opt.label))])
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "440"
          },
          model: {
            value: _vm.confirmDialog,
            callback: function callback($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog"
          }
        },
        [
          _vm.confirming
            ? _c(
                "gg-card",
                {
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "kvm-power-confirm-title"
                  }
                },
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "body-1 font-weight-medium mb-2",
                          attrs: {
                            id: "kvm-power-confirm-title"
                          }
                        },
                        [_vm._v(_vm._s(_vm.confirming.label) + "?")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "mb-4"
                        },
                        [_vm._v(_vm._s(_vm.confirming.confirm))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "text-right"
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                text: ""
                              },
                              on: {
                                click: function click($event) {
                                  _vm.confirmDialog = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                tile: "",
                                color: _vm.confirming.color
                              },
                              on: {
                                click: function click($event) {
                                  return _vm.submit(_vm.confirming)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.confirming.label))]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }